import React from "react";

const BillCheckboxes = (props) => {
  const { handleCheckbox, roommate, error } = props;
  return (
    <>
      <div className="w-80 mt-5 px-1">
        <div
          className={`grid grid-cols-2 gap-x-5 gap-y-3 ${error.splitsBills}`}
        >
          <div className="flex justify-between items-center">
            <div>Gas:</div>
            <input
              id="pays-gas"
              name="paysGas"
              type="checkbox"
              checked={roommate.paysGas}
              className="h-5 w-5"
              onChange={handleCheckbox}
            />
          </div>
          <div className="flex justify-between items-center">
            <div>Electricity:</div>
            <input
              id="pays-electric"
              name="paysElectric"
              type="checkbox"
              checked={roommate.paysElectric}
              className="h-5 w-5"
              onChange={handleCheckbox}
            />
          </div>
          <div className="flex justify-between items-center">
            <div>Water:</div>
            <input
              id="pays-water"
              name="paysWater"
              type="checkbox"
              checked={roommate.paysWater}
              className="h-5 w-5"
              onChange={handleCheckbox}
            />
          </div>
          <div className="flex justify-between items-center">
            <div>Sewer:</div>
            <input
              id="pays-sewer"
              name="paysSewer"
              type="checkbox"
              checked={roommate.paysSewer}
              className="h-5 w-5"
              onChange={handleCheckbox}
            />
          </div>
          <div className="flex justify-between items-center">
            <div>Cable:</div>
            <input
              id="pays-cable"
              name="paysCable"
              type="checkbox"
              checked={roommate.paysCable}
              className="h-5 w-5"
              onChange={handleCheckbox}
            />
          </div>
          <div className="flex justify-between items-center">
            <div>Telephone:</div>
            <input
              id="pays-phone"
              name="paysPhone"
              type="checkbox"
              checked={roommate.paysPhone}
              className="h-5 w-5"
              onChange={handleCheckbox}
            />
          </div>
          <div className="flex justify-between items-center">
            <div>Internet:</div>
            <input
              id="pays-internet"
              name="paysInternet"
              type="checkbox"
              checked={roommate.paysInternet}
              className="h-5 w-5"
              onChange={handleCheckbox}
            />
          </div>
          <div className="flex justify-between items-center">
            <div>HOA/Condo Fee:</div>
            <input
              id="pays-hoa"
              name="paysHoa"
              type="checkbox"
              checked={roommate.paysHoa}
              className="h-5 w-5"
              onChange={handleCheckbox}
            />
          </div>
          {/* <div className="flex  justify-center col-span-2 items-center gap-x-5">
            <div>Other:</div>
            <input
              id="pays-other"
              name="paysOther"
              type="checkbox"
              checked={roommate.paysOther}
              className="h-5 w-5"
              onChange={handleCheckbox}
            />
          </div> */}
        </div>
      </div>
      {/* {roommate.paysOther && (
        <label className={`grid mt-5 ${error.otherType}`}>
          <div>
            Other Description: <span className="text-red-500">*</span>
          </div>
          <input
            id="other-type"
            name="otherType"
            type="text"
            maxLength={30}
            placeholder="Description"
            value={roommate.otherType}
            autoFocus={true}
            className={`w-80 border-gray-300 border-1 rounded-md px-1 ${error.otherType}`}
            onChange={handleChange}
          />
        </label>
      )} */}
    </>
  );
};

export default BillCheckboxes;
